import { render, staticRenderFns } from "./HighlightedAddressText.vue?vue&type=template&id=1ea03295&scoped=true&"
import script from "./HighlightedAddressText.vue?vue&type=script&lang=js&"
export * from "./HighlightedAddressText.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedAddressText.vue?vue&type=style&index=0&id=1ea03295&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea03295",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea03295')) {
      api.createRecord('1ea03295', component.options)
    } else {
      api.reload('1ea03295', component.options)
    }
    module.hot.accept("./HighlightedAddressText.vue?vue&type=template&id=1ea03295&scoped=true&", function () {
      api.rerender('1ea03295', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Autocomplete/HighlightedAddressText.vue"
export default component.exports